export const formatSites = (sites) => {
  const provinces = [];

  sites.forEach((site) => {
    const [province, district, subDistrict, facility] = site.site.split(' - ');

    let provinceObject = provinces.find((p) => p.province === province);
    if (!provinceObject) {
      provinceObject = { province, districts: [] };
      provinces.push(provinceObject);
    }

    let districtObject = provinceObject.districts.find((d) => d.district === district);
    if (!districtObject) {
      districtObject = { district, subDistricts: [] };
      provinceObject.districts.push(districtObject);
    }

    let subDistrictObject = districtObject.subDistricts.find((sd) => sd.subDistrict === subDistrict);
    if (!subDistrictObject) {
      subDistrictObject = { subDistrict, facilities: [] };
      districtObject.subDistricts.push(subDistrictObject);
    }

    subDistrictObject.facilities.push({ facility, externalReference: site.externalReference });
  });

  return provinces;
};
